import {useEffect, useState} from "react";
import {Box, Button, Typography} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import {Navigate, useNavigate} from "react-router-dom";
import KioskSteps from "../components/KioskSteps";
import {useKioskLang, useKioskSession} from "../context/KioskSessionContext";

//結帳完成頁：LinePay 付款成功與櫃檯付款共用一頁（號碼＋指引＋倒數，不再分兩畫面）
export default function CompletePage({systemData}) {
  const navigate = useNavigate();
  const {state, resetSession} = useKioskSession();
  const {tr} = useKioskLang();
  const counter = state.paymentMethod === "counter";
  //櫃檯付款要留時間讓客人記住號碼與金額，倒數比已付款的完成頁長
  const completionSeconds = counter
    ? Number(systemData?.kiosk_settings?.counter_completion_seconds ?? 30)
    : Number(systemData?.kiosk_settings?.completion_seconds ?? 12);
  const [remaining, setRemaining] = useState(completionSeconds);

  useEffect(() => {
    const timer = setInterval(() => setRemaining((value) => value - 1), 1000);
    const redirect = setTimeout(() => {
      resetSession();
      navigate("/kiosk/welcome", {replace: true});
    }, completionSeconds * 1000);
    return () => {clearInterval(timer); clearTimeout(redirect);};
  }, [completionSeconds, navigate, resetSession]);

  if (!state.orderNo) return <Navigate to="/kiosk/welcome" replace/>;
  const done = () => {resetSession(); navigate("/kiosk/welcome", {replace: true});};
  return <Box sx={{height: "100dvh", display: "flex", flexDirection: "column", background: "radial-gradient(circle at center, #FFF 0%, #F3E3D0 72%)"}}>
    <KioskSteps active={3}/>
    <Box sx={{flex: 1, display: "grid", placeItems: "center", p: 4}}>
    <Box sx={{textAlign: "center"}}>
      {counter
        ? <StorefrontRoundedIcon sx={{fontSize: 96, color: "#A86F24", animation: "kioskPop .5s ease"}}/>
        : <CheckCircleRoundedIcon sx={{fontSize: 96, color: "#2E7D32", animation: "kioskPop .5s ease"}}/>}
      <Typography sx={{fontSize: 42, fontWeight: 950, mt: 1}}>{counter ? tr("orderCreated") : tr("paySuccess")}</Typography>
      <Typography color="text.secondary" sx={{fontSize: 21, mt: 1}}>{counter ? tr("orderCreatedText") : tr("paySuccessText")}</Typography>
      <Box sx={{my: 2.5, mx: "auto", width: "fit-content", px: 5, py: 1.5, borderRadius: 2, bgcolor: "#FFF6F1", border: "2px dashed", borderColor: "primary.main"}}>
        <Typography sx={{fontSize: 15, fontWeight: 900, color: "text.secondary", letterSpacing: ".2em"}}>{tr("orderNumber")}</Typography>
        <Typography sx={{fontSize: 88, lineHeight: 1.15, fontWeight: 950, color: "primary.main", letterSpacing: ".04em"}}>{state.orderNo}</Typography>
      </Box>
      {counter && <Typography sx={{fontSize: 25, fontWeight: 900, mb: 1}}>{tr("amountDue", {n: Number(state.pricing?.total ?? 0).toLocaleString()})}</Typography>}
      <Typography sx={{fontSize: 22, fontWeight: 800}}>
        {Number(state.orderMethod) === 3
          ? `${tr("dineIn")}${state.tableNumber ? ` · ${tr("tableChip", {n: state.tableNumber})}` : ""}`
          : tr("takeout")}
      </Typography>
      {Number(state.orderMethod) === 2 && state.memberMobile && (
        <Typography color="text.secondary" sx={{fontSize: 18, mt: .75}}>{tr("pickupMobileShown", {mobile: state.memberMobile})}</Typography>
      )}
      <Button variant="contained" onClick={done} sx={{mt: 3, minWidth: 300}}>{tr("doneCountdown", {n: Math.max(0, remaining)})}</Button>
    </Box>
    </Box>
  </Box>;
}
